<template>
  <div class="ClaimStep2">
    <div class="loading" id="loading" v-show="loading">
      <div class="circle"></div>
    </div>
    <div class="model">
      <div class="body">
        <p class="title"></p>
        <p class="content"></p>
        <p class="foot"></p>
      </div>
    </div>
    <div class="loading" id="loading" style="display: none;">
      <div class="circle"></div>
    </div>
    <div class="main" style="padding-bottom: 50px;">
      <p class="doc_title" style="margin-bottom:10px;">如果您的资金不幸被盗，请按以下步骤进行索赔登记</p>
      <p class="doc_text">1.手持身份证拍照（正反面）</p>
      <div class="upload">
        <div class="item item1">
          <wk-single-image-upload
            dest="wifikey"
            @change="getIdCardFront"
            v-model="formData.photoIdCardEvidenceFront"
            :disabled="disabled"
          >
            <solt name="loading" class="loading"></solt>
          </wk-single-image-upload>
          <button>上传照片</button>
          <div class="desc">已上传</div>
        </div>
        <div class="item item2">
          <wk-single-image-upload
            dest="wifikey"
            @change="getIdCardFront"
            v-model="formData.photoIdCardEvidenceReverse"
            :disabled="disabled"
          >
            <solt name="loading" class="loading"></solt>
          </wk-single-image-upload>
          <button>上传照片</button>
          <div class="desc">已上传</div>
        </div>
      </div>
      <p class="doc_text" style="margin-top:20px">2.被盗信息截屏</p>
      <div class="upload">
        <div class="item screenShot">
          <wk-single-image-upload
            @change="getIdCardFront"
            v-model="formData.photoStolenEvidence"
            :disabled="disabled"
          >
            <solt name="loading" class="loading"></solt>
          </wk-single-image-upload>
          <button>上传照片</button>
          <div class="desc">已上传</div>
        </div>
      </div>
      <p class="button" style="margin-top:25px;" @click="claimStep2">确认登记</p>
      <p class="doc_a" style="margin-top: 15px;">
        <router-link to="/new/claimFlow">了解索赔流程</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import Toast from "@/components/toast";
const AES = require("@/lib/Utils/AES").default;
import wkSingleImageUpload from "../components/SingleImageUpload";
import { commitClam } from "../services/common/index";

export default {
  name: 'newclaimStep2',
  components: {
    wkSingleImageUpload,
  },
  data() {
    return {
      appinfo: "",
      disabled: false,
      order_sn: "",
      loading: false,
      question: [],
      formData: {
        photoStolenEvidence: "",
        photoIdCardEvidenceFront: "",
        photoIdCardEvidenceReverse: "",
      },
    };
  },
  created() {
    this.question = this.$route.query.params;
    console.log(`===`, this.question);
  },
  mounted() {
    // this.$trace.enterTraceDone({ page: 7, step: 2 });
  },

  methods: {
    getIdCardFront() {

    },
    claimStep2 () {
      this.$trace.trace('ins_claim_confirm',  { step: 2, type: 'sup' });
      let error;
      if (!this.formData.photoIdCardEvidenceFront) {
        error = "身份证正面";
      } else if (!this.formData.photoIdCardEvidenceReverse) {
        error = "身份证反面";
      } else if (!this.formData.photoStolenEvidence) {
        error = "被盗信息截屏";
      }

      if (error) {
        safe.model({
          title: "温馨提示",
          content: error + "未上传完成",
          foot: "我知道了",
        });
        safe.bindModelEvent();
        return;
      }

      let params = {
        ...this.formData,
        stolenState: this.question,
        photoStolenEvidence: JSON.stringify([this.formData.photoStolenEvidence]) || [],
        // photoIdCardEvidenceFront: "http://uimg01.51y5.net/wk003/M00/5D/09/CgIagV9d-NWAJVkCAABpUM_9h7M266.png",
        // photoIdCardEvidenceReverse: "http://uimg01.51y5.net/wk003/M00/5D/09/CgIagV9d-NWAJVkCAABpUM_9h7M266.png",
        // photoStolenEvidence: JSON.stringify(["http://uimg01.51y5.net/wk003/M00/5D/09/CgIagV9d-NWAJVkCAABpUM_9h7M266.png"]),
      };

      console.log(`=====`, params.photoStolenEvidence)
      commitClam( params ).then((res) => {
        const { retCd, msg } = res;
        if (retCd === '0') {
          this.$router.push("/new/claimSuccess");
        } else {
          Toast(msg)
        }
      }).catch(err=> {
        const { retCd, msg } = err;
          if (retCd === "T.XQA.2013") {
            this.$toast(msg)
          }
      });
    }
  },
};
</script>

<style scoped>
.doc_text {
  position: relative;
}
.upload {
  padding-left: 6%;
  display: flex;
}
.upload .item {
  display: inline-block;
  position: relative;
  width: 100px;
  height: 100px;
  background-color: #ffffff;
  border: 1px solid #dbdbdb;
  background-repeat: no-repeat;
  background-image: url(../images/id_no.png);
  -webkit-background-size: 40px 30px;
  background-size: 80px;
  background-position: center;
  margin-right: 10px;
  text-align: center;
}
.upload .uploaded {
  display: inline-block;
  position: relative;
  width: 100px;
  height: 100px;
  background-color: #ffffff;
  border: 1px solid #dbdbdb;
  background-repeat: no-repeat;
  background-image: url(../images/id_ok.png);
  -webkit-background-size: 40px 30px;
  background-size: 80px;
  background-position: center;
  margin-right: 10px;
  text-align: center;
}

.upload .item button {
  position: absolute;
  background-color: #15cb73;
  width: 86px;
  height: 24px;
  border: none;
  color: #ffffff;
  font-size: 13px;
  bottom: 6px;
  margin-left: -43px;
  left: 50%;
  z-index: 1;
}
.upload .item .desc {
  display: none;
}
.upload .item button:active {
  background-color: #12ae63;
}
.upload .item input[type="file"] {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
}
.upload .screenShot {
  background-image: url(../images/cut_no.png);
}
.upload .screen {
  background-image: url(../images/cut_ok.png);
}

.upload .uploaded button {
  display: none;
}
.upload .uploaded .desc {
  display: block;
  position: absolute;
  width: 86px;
  height: 24px;
  border: none;
  color: #000;
  font-size: 13px;
  bottom: 0px;
  margin-left: -43px;
  left: 50%;
  z-index: 1;
}

.upload-img {
  background: #f7f7f7;
  /* border: 1px solid #E8E8E8; */
  border-radius: 4px;
  margin: 10px 0;
  width: 86px;
  background-image: url(../images/id_no.png);
  -webkit-background-size: 40px 30px;
  background-size: 80px;
  height: 86px;
}
</style>



// WEBPACK FOOTER //
// claimStep2.vue?66fe4df6